export default class HeroSlider {
    constructor($el) {
        this.$el = $el;
        this.$slides = [...$el.querySelectorAll('[data-hero-slide]')];
        this.$dots = [...$el.querySelectorAll('[data-hero-slider-dot]')];
        this.activeIndex = 0;
        this.interval = 5000;
        this.autoplay = null;
        this.pointerStartX = null;
        this.pointerStartY = null;
        this.pointerId = null;
        this.swipeThreshold = 40;

        if (this.$slides.length < 2 || $el.dataset.heroSliderInitialized === 'true') {
            return;
        }

        $el.dataset.heroSliderInitialized = 'true';

        this.showSlide = this.showSlide.bind(this);
        this.showNext = this.showNext.bind(this);
        this.showPrevious = this.showPrevious.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onPointerCancel = this.onPointerCancel.bind(this);
        this.restartAutoplay = this.restartAutoplay.bind(this);

        this.$dots.forEach(($dot, index) => {
            $dot.addEventListener('click', () => {
                this.showSlide(index);
                this.restartAutoplay();
            });
        });

        this.$el.addEventListener('pointerdown', this.onPointerDown, {passive: true});
        this.$el.addEventListener('pointerup', this.onPointerUp, {passive: true});
        this.$el.addEventListener('pointercancel', this.onPointerCancel, {passive: true});
        this.$el.addEventListener('mouseenter', () => this.stopAutoplay());
        this.$el.addEventListener('mouseleave', this.restartAutoplay);
        this.$el.addEventListener('focusin', () => this.stopAutoplay());
        this.$el.addEventListener('focusout', () => {
            if (!this.$el.contains(document.activeElement)) {
                this.restartAutoplay();
            }
        });

        this.showSlide(0);
        this.startAutoplay();
    }

    showSlide(index) {
        const nextIndex = (index + this.$slides.length) % this.$slides.length;
        this.activeIndex = nextIndex;

        this.$slides.forEach(($slide, slideIndex) => {
            $slide.classList.toggle('is-active', slideIndex === nextIndex);
        });

        this.$dots.forEach(($dot, dotIndex) => {
            const isActive = dotIndex === nextIndex;
            $dot.classList.toggle('is-active', isActive);
            $dot.setAttribute('aria-current', String(isActive));
        });
    }

    showNext() {
        this.showSlide(this.activeIndex + 1);
    }

    showPrevious() {
        this.showSlide(this.activeIndex - 1);
    }

    startAutoplay() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        this.stopAutoplay();
        this.autoplay = window.setInterval(this.showNext, this.interval);
    }

    stopAutoplay() {
        if (this.autoplay) {
            window.clearInterval(this.autoplay);
            this.autoplay = null;
        }
    }

    restartAutoplay() {
        this.startAutoplay();
    }

    onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) {
            return;
        }

        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
    }

    onPointerUp(event) {
        if (
            this.pointerStartX === null
            || this.pointerStartY === null
            || (this.pointerId !== null && event.pointerId !== this.pointerId)
        ) {
            return;
        }

        const deltaX = event.clientX - this.pointerStartX;
        const deltaY = event.clientY - this.pointerStartY;

        this.onPointerCancel();

        if (Math.abs(deltaX) < this.swipeThreshold || Math.abs(deltaY) > Math.abs(deltaX)) {
            return;
        }

        if (deltaX < 0) {
            this.showNext();
        } else {
            this.showPrevious();
        }

        this.restartAutoplay();
    }

    onPointerCancel() {
        this.pointerId = null;
        this.pointerStartX = null;
        this.pointerStartY = null;
    }
}
